import { render } from "./DashboardsChartCard.vue?vue&type=template&id=60e90b44&scoped=true&ts=true"
import script from "./DashboardsChartCard.vue?vue&type=script&lang=ts"
export * from "./DashboardsChartCard.vue?vue&type=script&lang=ts"

import "./DashboardsChartCard.vue?vue&type=style&index=0&id=60e90b44&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e90b44"]])

export default __exports__